import { render, staticRenderFns } from "./DashboardBanner.vue?vue&type=template&id=3c9f1f0a&scoped=true&"
import script from "./DashboardBanner.vue?vue&type=script&lang=js&"
export * from "./DashboardBanner.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBanner.vue?vue&type=style&index=0&id=3c9f1f0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9f1f0a",
  null
  
)

export default component.exports